//Método para exibir ou não conteudo baseado em uma flag.
//Se verdadeiro exibe, se falso oculta
//Inserir o método no parâmetro style de qualquer componente mantine.
import {Forca} from "../tipos/forca";

export function displayFlagStyle(f: boolean) {
    if (f) return {}
    return {display: "none"}
}
export function displayFlagClasse(f: boolean) {
    if (f) return ""
    return "display-none"
}

export function dateParser(d: string | Date | null | undefined) {
    if (d == null || d instanceof Date) return d
    return new Date(d)
}

export function getForca(sigla: string, forcas: Forca[]) {
    const f = forcas.find(forca => forca.sigla === sigla)
    return f !== undefined ? f : new Forca();
}